/**
 * Send information to Tealium / Google Analytics when an item is removed from the cart.
 * @param {Object} params Tealium attributes to track @see {@link _client\features\tealium\configs\ecommerceLevelAttributes.js|ecommerceLevelAttributes}
 */
function removeFromCart (params) {

	if (window.utag) {

		const data = {
			event_name: 'cart_remove',
			event_category: 'ecommerce',
			event_action: 'remove from cart',
			event_label: params.product_sku?.join() ?? '',
			...params
		};

		// Items were removed from the cart
		// then track 'remove from cart' event and redirect to cart.
		const utagTrackingPromise = new Promise((resolve) => {

			// utag.link() returns true, or undefined if tracking is blocked
			const wasSuccessful = window.utag.link(data, () => resolve());
			if (wasSuccessful) resolve();

			// Tracking is allowed 500ms for successful resolution,
			// then we resolve the promise regardless.
			setTimeout(() => resolve(), 500);

		});

	}

}

export default removeFromCart;
